import { Dictionary } from "@insite/client-framework/Common/Types";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter, request } from "@insite/client-framework/Services/ApiService";
import { GetOrderStatusMappingsApiParameter } from "@insite/client-framework/Services/OrderService";
import { OrderStatusMappingCollectionModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {},
    GetOrderStatusMappingsApiParameter,
    OrderStatusMappingCollectionModel
>;

export const DispatchBeginLoadOrderStatusMapping: HandlerType = props => {
    props.dispatch({
        type: "Data/OrderStatusMappings/BeginLoadOrderStatusMappings",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {};
};

export function getUpdatedOrderStatus<T>(
    endpoint: string,
    parameter: ApiParameter = {},
    queryStringParameters: Dictionary<any> = {},
) {
    let queryString = "";
    const combinedQueryString: Dictionary<any> = {
        ...parameter,
        ...parameter.additionalQueryStringParameters,
        ...queryStringParameters,
    };

    const additionalExpands = combinedQueryString["additionalExpands"];
    if (additionalExpands) {
        if (!combinedQueryString["expand"]) {
            combinedQueryString["expand"] = [];
        }
        combinedQueryString["expand"] = combinedQueryString["expand"].concat(additionalExpands);
        delete combinedQueryString["additionalExpands"];
    }

    for (const key in combinedQueryString) {
        if (key !== "additionalQueryStringParameters" && combinedQueryString[key] !== undefined) {
            if (key !== "expand" && key !== "exclude" && Array.isArray(combinedQueryString[key])) {
                // WebApi requires arrays to be split into individual query string values
                combinedQueryString[key].forEach((p: string) => {
                    queryString += `${key}=${encodeURIComponent(p)}&`;
                });
            } else {
                queryString += `${key}=${encodeURIComponent(combinedQueryString[key])}&`;
            }
        }
    }

    if (queryString !== "") {
        queryString = (endpoint.indexOf("?") < 0 ? "?" : "&") + queryString.substr(0, queryString.length - 1);
    }

    return request<T>(
        endpoint + queryString,
        "GET",
        { "Cache-Control": "no-cache", Pragma: "no-cache" },
        "",
        undefined,
        "no-cache",
    );
}

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getOrderStatusMappingsOverride(props.apiParameter);
};

export function getOrderStatusMappingsOverride(parameter: GetOrderStatusMappingsApiParameter) {
    return getUpdatedOrderStatus<OrderStatusMappingCollectionModel>("/api/v1/orderstatusmappings", parameter);
}

export const DispatchCompleteLoadOrderStatusMapping: HandlerType = props => {
    props.dispatch({
        type: "Data/OrderStatusMappings/CompleteLoadOrderStatusMappings",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    DispatchBeginLoadOrderStatusMapping,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadOrderStatusMapping,
];

const loadOrderStatusMappings = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadOrderStatusMappings");
export default loadOrderStatusMappings;
